import React, { FC } from 'react'
import { Grid, CircularProgress } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    zIndex: 10000,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.3)',
  },
  bottom: {
    position: 'fixed',
  },
  top: {
    animationDuration: '550ms',
    position: 'fixed',
  },
  circle: {
    strokeLinecap: 'round',
  },
}))

export const Loader: FC = () => {
  const classes = useStyles()
  return (
    <Grid container className={classes.root}>
      <CircularProgress variant="determinate" className={classes.bottom} size={40} thickness={4} value={100} />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        className={classes.top}
        classes={{
          circle: classes.circle,
        }}
        size={40}
        thickness={4}
      />
    </Grid>
  )
}
